import React from 'react';
import { FaClock, FaCheck, FaTimes, FaSpinner } from 'react-icons/fa';

export function PendingApprovalsSection({ 
  pendingApprovals, 
  processingApproval, 
  onApprove, 
  onReject 
}) {
  if (pendingApprovals.length === 0) return null;

  return (
    <div className="bg-white rounded-xl border-2 border-amber-300 p-6" data-testid="pending-approvals-section">
      <div className="flex items-center gap-3 mb-4">
        <div className="p-2 bg-amber-100 rounded-full">
          <FaClock className="text-amber-600" />
        </div>
        <h4 className="text-lg font-semibold text-gray-800">Pending Approvals</h4>
        <span className="px-2 py-1 bg-amber-100 text-amber-700 text-sm font-medium rounded-full">
          {pendingApprovals.length}
        </span>
      </div>
      <p className="text-sm text-gray-600 mb-4">
        These people have created accounts and are waiting for your approval to join the family.
      </p>
      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
        {pendingApprovals.map((approval) => (
          <div
            key={approval.invitation_id}
            className="bg-amber-50 rounded-xl border border-amber-200 p-4"
            data-testid={`approval-card-${approval.invitation_id}`}
          >
            <div className="flex items-start space-x-3 mb-3">
              <div className="w-10 h-10 rounded-full bg-amber-200 flex items-center justify-center flex-shrink-0">
                <span className="text-amber-700 font-bold">
                  {approval.created_user_name?.charAt(0).toUpperCase() || '?'}
                </span>
              </div>
              <div className="flex-1 min-w-0">
                <h5 className="font-semibold text-gray-800 truncate">{approval.created_user_name}</h5>
                <p className="text-sm text-gray-600 truncate">{approval.proxy_email}</p>
                <p className="text-xs text-gray-500">Invited by {approval.invited_by_name}</p>
              </div>
            </div>
            <div className="flex gap-2">
              <button
                onClick={() => onApprove(approval.invitation_id)}
                disabled={processingApproval === approval.invitation_id}
                className="flex-1 flex items-center justify-center space-x-1 px-3 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 disabled:opacity-50 text-sm font-medium"
                data-testid={`approve-btn-${approval.invitation_id}`}
              >
                {processingApproval === approval.invitation_id ? (
                  <FaSpinner className="animate-spin" />
                ) : (
                  <>
                    <FaCheck />
                    <span>Approve</span>
                  </>
                )}
              </button>
              <button
                onClick={() => onReject(approval.invitation_id, approval.created_user_name)}
                disabled={processingApproval === approval.invitation_id}
                className="flex-1 flex items-center justify-center space-x-1 px-3 py-2 bg-red-100 text-red-700 rounded-lg hover:bg-red-200 disabled:opacity-50 text-sm font-medium"
                data-testid={`reject-btn-${approval.invitation_id}`}
              >
                <FaTimes />
                <span>Reject</span>
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
